import React, { useEffect, useState, useRef } from 'react';
import { SolarUserList } from '../../types/solar_user';
import { getSolarUserList } from '../../services/solarService';
import { SolarProvider, SolarUser } from '../../types/solar_user';
import { updateSolarUser, getAllProviders } from '../../services/solarService';




const FetchSolarUserList: React.FC = () => {
    const [solarUsers, setSolarUserList] = useState<SolarUserList[]>([]);
    const [userIndex, setUserIndex] = useState<number>(-1);
    const tableRef = useRef<HTMLTableElement>(null);
    const [solarProviders, setSolarProvider] = useState<SolarProvider[]>([]);

    const [user, setUser] = useState<SolarUser>({
        provider_id: '',
        user_id: 0,
        user_name: '',
        password: '',
        capacity: '',
        consumer_name: '',
        consumer_type: '',
        discom_number: '',
        created_by: 1,
        updated_by: 1,
        provider_name: '',
        updated_at: '',
    });

    const onEditClick = (index: number) => {
        console.log('Edit clicked for index:', index);
        setUserIndex(index);
        setUser(solarUsers[0]?.data[index]);
        // You can add more logic here to handle the edit action
    }

    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        // Call API to add user
        console.log(user);
        updateSolarUser(user)
            .then((response) => {
                console.log('User added successfully:', response);
                window.location.reload();
            })
            .catch((error) => {
                console.error('Error adding user:', error);
            });
        // Reset form
        setUser({
            provider_id: '',
            user_id: 0,
            user_name: '',
            password: '',
            capacity: '',
            consumer_name: '',
            consumer_type: '',
            discom_number: '',
            created_by: 1,
            updated_by: 1,
            provider_name: '',
            updated_at: '',
        });
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        setUser({
            ...user,
            [event.target.name]: event.target.value,
        });
    };

    useEffect(() => {

        const initDataTable = () => {
            if (tableRef.current) {
                const table = $(tableRef.current);
                table.DataTable({
                    language: {
                        emptyTable: 'Data is being fetched...',
                    },
                });
            }
        };
        const fetchSolarUsers = async () => {
            try {
                const response = await getSolarUserList({});
                setSolarUserList([{ data: response.data }]);
            } catch (error) {
                console.error('Error fetching solar users:', error);
            }
        };

        fetchSolarUsers();
        $(function () {
            initDataTable();

        });

        const getAllSolarProviders = async () => {
            await getAllProviders({}).then((data) => {
            setSolarProvider(prevProviders => [...prevProviders, data]);
            }).catch((error) => {
                console.error('Error fetching providers:', error);
            });
        };
        getAllSolarProviders();
        
    }, []);
    return (
        <div>
            <div className="modal fade animated--grow-in" id="updateSolarUserModal" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Update Solar User</h5>
                            <button className="close" type="button" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">

                            <form onSubmit={handleSubmit}>
                                <div className='row'>
                                    <div className='col-xl-6 col-lg-6'>
                                        <div className="form-group">
                                            <label>
                                                Provider Name:
                                                <select
                                                    name="provider_id"
                                                    className="form-control form-control-user"
                                                    onChange={handleChange}
                                                    value={user.provider_id}>
                                                    <option value="-1">Select Provider</option>
                                                    {solarProviders.map((provider) => (
                                                        provider.data.map(element => (
                                                            <option key={element.provider_id} value={element.provider_id}>
                                                            {element.provider_name}
                                                            </option>
                                                        ))
                                                    ))}


                                                </select>

                                            </label>
                                        </div>
                                        <div className="form-group">
                                            <label>
                                                Solar User Name:
                                                <input
                                                    type="text"
                                                    name="user_name"
                                                    className="form-control form-control-user"
                                                    value={user.user_name}
                                                    onChange={handleChange}
                                                />
                                            </label>
                                        </div>
                                        <div className="form-group">
                                            <label>
                                                Solar Consumer Name:
                                                <input
                                                    type="text"
                                                    name="consumer_name"
                                                    className="form-control form-control-user"
                                                    value={user.consumer_name}
                                                    onChange={handleChange}
                                                />
                                            </label>
                                        </div>
                                        <div className="form-group">
                                            <label>
                                                Solar Consumer Type:
                                                <input
                                                    type="text"
                                                    name="consumer_type"
                                                    className="form-control form-control-user"
                                                    value={user.consumer_type}
                                                    onChange={handleChange}
                                                />
                                            </label>
                                        </div>
                                        <div className="form-group">
                                            <label>
                                                Solar Consumer Discom Number:
                                                <input
                                                    type="text"
                                                    name="discom_number"
                                                    className="form-control form-control-user"
                                                    value={user.discom_number}
                                                    onChange={handleChange}
                                                />
                                            </label>
                                        </div>
                                        <div className="form-group">
                                            <label>
                                                Solar Password:
                                                <input
                                                    type="text"
                                                    name="password"
                                                    className="form-control form-control-user"
                                                    value={user.password}
                                                    onChange={handleChange}
                                                />
                                            </label>
                                        </div>
                                        <div className="form-group">
                                            <label>
                                                Capacity:
                                                <input
                                                    type="text"
                                                    name="capacity"
                                                    className="form-control form-control-user"
                                                    value={user.capacity}
                                                    onChange={handleChange}
                                                />
                                            </label>
                                        </div>
                                        <div className="form-group">
                                            <label>
                                                Capacity Unit:
                                                <input
                                                    type="text"
                                                    name="capacity_unit"
                                                    className="form-control form-control-user"
                                                    value={user.capacity_unit}
                                                    onChange={handleChange}
                                                />
                                            </label>
                                        </div>
                                    </div>
                                    <div className='col-xl-6 col-lg-6'>
                                        <div className="form-group">
                                            <label>
                                                Address Line 1:
                                                <input
                                                    type="text"
                                                    name="address_line1"
                                                    className="form-control form-control-user"
                                                    value={user.address_line1}
                                                    onChange={handleChange}
                                                />
                                            </label>
                                        </div>
                                        <div className="form-group">
                                            <label>
                                                Address Line 2:
                                                <input
                                                    type="text"
                                                    name="address_line2"
                                                    className="form-control form-control-user"
                                                    value={user.address_line2}
                                                    onChange={handleChange}
                                                />
                                            </label>
                                        </div>
                                        <div className="form-group">
                                             <label>
                                                Village
                                                <input
                                                    type="text"
                                                    name="village"
                                                    className="form-control form-control-user"
                                                    value={user.village}
                                                    onChange={handleChange}
                                                />
                                            </label>
                                        </div>
                                        <div className="form-group">
                                            <label>
                                                Taluka
                                                <input
                                                    type="text"
                                                    name="taluka"
                                                    className="form-control form-control-user"
                                                    value={user.taluka}
                                                    onChange={handleChange}
                                                />
                                            </label>
                                        </div>
                                        <div className="form-group">
                                            <label>
                                                District
                                                <input
                                                    type="text"
                                                    name="district"
                                                    className="form-control form-control-user"
                                                    value={user.district}
                                                    onChange={handleChange}
                                                />
                                            </label>
                                        </div>
                                        <div className="form-group">
                                            <label>
                                                Pin Code
                                                <input
                                                    type="text"
                                                    name="zip_code"
                                                    className="form-control form-control-user"
                                                    value={user.zip_code}
                                                    onChange={handleChange}
                                                />
                                            </label>
                                        </div>
                                        <div className="form-group">
                                            <label>
                                                Lat Long
                                                <input
                                                    type="text"
                                                    name="lat_long"
                                                    className="form-control form-control-user"
                                                    value={user.lat_long}
                                                    onChange={handleChange}
                                                />
                                            </label>
                                            
                                        </div>
                                        <div className="form-group">
                                            <label>
                                                Country
                                                <input
                                                    type="text"
                                                    name="country"
                                                    className="form-control form-control-user"
                                                    value={user.country}
                                                    onChange={handleChange}
                                                />
                                            </label>
                                            
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group modal-footer">
                                    <button className="btn btn-primary" type="submit">Update</button>
                                    <button className="btn btn-secondary" type="button" data-dismiss="modal">Cancel</button>
                                </div>
                            </form>


                        </div>

                    </div>
                </div>
            </div>
            <div className="card shadow mb-4">
                <div className="card-header py-3">
                    <h6 className="m-0 font-weight-bold text-primary">Solar User List</h6>
                </div>
                <div className="card-body">
                    <div className="table-responsive">
                        <div id="dataTable_wrapper" className="dataTables_wrapper dt-bootstrap4">
                            <div className="row">
                                <div className="col-sm-12 col-md-6">
                                    <div className="dataTables_length" id="dataTable_length">
                                    </div>
                                </div>

                            </div>
                            <div className="row"><div className="col-sm-12">
                                <table className="table table-bordered dataTable" id="dataTable" width="100%" cellSpacing="0" role="grid" aria-describedby="dataTable_info" >
                                    <thead>
                                        <tr role="row">
                                            <th className="sorting sorting_asc" tabIndex={0} aria-controls="dataTable" rowSpan={1} colSpan={1} aria-sort="ascending" aria-label="Name: activate to sort column descending" >Consumer Name</th>
                                            <th className="sorting" tabIndex={1} aria-controls="dataTable" rowSpan={1} colSpan={1} aria-label="Position: activate to sort column ascending" >User Name</th>
                                            <th className="sorting" tabIndex={1} aria-controls="dataTable" rowSpan={1} colSpan={1} aria-label="Office: activate to sort column ascending" >Consumer Type</th>
                                            <th className="sorting" tabIndex={1} aria-controls="dataTable" rowSpan={1} colSpan={1} aria-label="Age: activate to sort column ascending" >Discom Number</th>
                                            <th className="sorting" tabIndex={1} aria-controls="dataTable" rowSpan={1} colSpan={1} aria-label="Start date: activate to sort column ascending" >Provider Name</th>
                                            <th className="sorting" tabIndex={1} aria-controls="dataTable" rowSpan={1} colSpan={1} aria-label="Salary: activate to sort column ascending">Action</th>
                                        </tr>
                                    </thead>

                                    <tbody key="1">
                                        {solarUsers.map((user) => (
                                            <>
                                                {user.data.map((data, index) => (
                                                    <tr key={index} role="row" className={index % 2 === 0 ? 'even' : 'odd'}>
                                                        <td key={data.consumer_name}>{data.consumer_name}</td>
                                                        <td>{data.user_name}</td>
                                                        <td>{data.consumer_type}</td>
                                                        <td>{data.discom_number}</td>
                                                        <td>{data.provider_name}</td>
                                                        <td>
                                                            <div className="card-body no-arrow">
                                                                <a className="" href="#" data-toggle="modal" data-target="#updateSolarUserModal"
                                                                    data-id="{updateSolarUserModal}" onClick={() => onEditClick(index)} title="Edit User">
                                                                    <i className="fas fa-pencil-alt fa-sm fa-fw mr-2 text-gray-400"></i>

                                                                </a> | &nbsp;
                                                                <a className="" href={'/user-dashboard/' + data.user_id}
                                                                >
                                                                    <i className="fas fa-tachometer-alt fa-sm fa-fw mr-2" title='User Dashboard'></i>
                                                                </a>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            </div>
                            <div className="row">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FetchSolarUserList;